import MinimizeIcon from '@assets/icons/learning-overview/minimize.svg';
import { BaseInput } from '@components/input';
import { BaseSelect } from '@components/select';
import { BaseSpin } from '@components/spin';
import { BODY_SM_SM_STYLES } from '@constants/text.ts';
import { Drawer } from 'antd';
import styled from 'styled-components';
export const ReaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    background: var(--colors-grey-150, #f1f4f8);
    border: 1px solid var(--colors-pdf-grey, #e8e8e8);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    width: 100%;
    height: 100%;
    min-height: 0;

    #current-page-input {
        width: 70px;
        ${BODY_SM_SM_STYLES};
        padding: 10px 16px;
    }
    .ant-select {
        padding: 2px 6px !important;
    }
    .ant-select-selector {
        padding: 10px 16px !important;

        span {
            ${BODY_SM_SM_STYLES};
            font-size: 14px !important;
        }
    }
    .ant-drawer-content-wrapper {
        width: 165px !important;
        margin-top: 63px;

        .ant-drawer-content {
            background: var(--neutral-150, #f1f4f8);
        }
    }
    .rc-virtual-list-holder {
        scrollbar-width: thin;
        scrollbar-color: var(--neutral-350, #b4b8bf) transparent;
    }
`;

export const ToolbarContainer = styled.div`
    border-bottom: 1px solid var(--colors-pdf-grey, #e8e8e8);
    flex-shrink: 0;
`;

export const ToolbarRow = styled.div`
    display: flex;
    align-items: center;
    padding: 8px 16px;
    justify-content: space-between;
`;

export const Group = styled.div`
    display: flex;
    align-items: center;
    position: relative;
`;

export const Separator = styled.div`
    width: 1px;
    height: 24px;
    background: var(--colors-pdf-grey, #e8e8e8);
    margin: 0 10px;
`;

export const IconButton = styled.button<{ toggled?: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    color: ${({ toggled }) => (toggled ? '#1890ff' : 'inherit')};
    font-size: 18px;

    &:disabled {
        opacity: 0.4;
        cursor: default;
    }
`;

export const ToggleActionIcon = styled(IconButton)<{ $toggled?: boolean }>`
    padding: 0;
    border-radius: var(--border-radius-s_8, 8px);
    background: ${({ $toggled }) => ($toggled ? 'var(--Neutral-400, #BCC8D6)' : 'none')};
`;

export const NumberInput = styled(BaseInput)`
    && {
        width: 60px;
        padding: 2px 4px;
        border-radius: 4px;
        margin: 0 4px;
    }
`;

export const ScaleSelect = styled(BaseSelect)`
    && {
        padding: 6px 6px;
        margin: 0 4px;
    }
`;

export const Label = styled.span`
    margin-left: 4px;
    ${BODY_SM_SM_STYLES};
    color: var(--colors-text-body, #50566e);
`;

export const DoorHanger = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    background: lightgray;
    border: 1px solid var(--colors-pdf-grey, #e8e8e8);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    padding: 8px;
    z-index: 1000;
`;

export const SecondaryMenu = styled(DoorHanger)`
    min-width: 200px;
    & > button,
    & > a {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 6px 8px;
        background: none;
        border: none;
        text-align: left;
        cursor: pointer;
        font-size: 14px;
    }
    & > button:hover {
        border-radius: var(--border-radius-xs_4, 4px);
        background: var(--colors-surface-page, #e7f4ff);
    }
    border-radius: var(--border-radius-xs_4, 4px);
    background: var(--colors-surface-primary, #fff);
    box-shadow:
        0 0 0 1px rgba(152, 161, 178, 0.1),
        0 15px 35px -5px rgba(17, 24, 38, 0.15),
        0 5px 15px 0 rgba(0, 0, 0, 0.08);
`;

export const SecondaryMenuDivider = styled.div`
    height: 1px;
    background: var(--colors-pdf-grey, #e8e8e8);
    margin: 8px 0;
`;

export const MenuItem = styled.button`
    display: flex;
    align-items: center;
    width: 100%;
    padding: 6px 8px;
    background: none;
    border: none;
    text-align: left;
    cursor: pointer;
    font-size: 14px;
    margin: 4px 0;

    &:disabled {
        opacity: 0.4;
        cursor: default;
    }
`;

export const DrawerWrapper = styled(Drawer)`
    position: absolute;

    .ant-drawer-body {
        padding: 4px;
        overflow: hidden;
    }
`;

//Viewer
export const ViewerContainer = styled.div`
    display: flex;
    justify-content: center;
    position: relative;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    background: var(--colors-grey-200, #e2e8f0);

    .rc-virtual-list-holder {
        overflow-y: auto;
        overscroll-behavior-y: contain;
        scrollbar-width: none !important;
        -ms-overflow-style: none;
    }

    .rc-virtual-list-holder::-webkit-scrollbar {
        display: none !important;
    }
`;
export const ViewerCanvasWrapper = styled.canvas`
    display: block;
    max-width: 100%;
    height: auto;
    margin: 0 auto 16px;
`;

//Thumbnail
export const ThumbnailWrapper = styled.div`
    cursor: pointer;
    margin-bottom: 12px;
`;

export const ThumbnailContainer = styled.div<{ $isSelected: boolean }>`
    border: ${({ $isSelected }) =>
        $isSelected ? '2px solid var(--colors-grey-300, #d3dbe5)' : '1px solid var(--colors-grey-200, #e2e8f0)'};
    border-radius: 4px;
    padding: 2px;
    cursor: pointer;
`;

export const ThumbnailNumberWrapper = styled.div`
    text-align: center;
    font-size: 12px;
    margin-top: 4px;
`;

export const ThumbnailCanvasWrapper = styled.canvas`
    display: block;
    width: 100%;
`;

export const ThumbnailSpinner = styled(BaseSpin)`
    display: flex;
    justify-content: center;
`;

export const MinimizeIconWrapper = styled(MinimizeIcon)`
    cursor: pointer;
    pointer-events: auto;
`;

export const MinimizeButton = styled.button`
    position: absolute;
    top: 30px;
    right: 30px;
    background: none;
    border: none;
    padding: 0;
`;
